import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Flex, Input } from 'antd';
import { useTheme } from '../../context/ThemeContext';
import { DARK } from '../../utilities/constants';
import Icon from '@ant-design/icons';
import { ReactComponent as Search } from '../../assets/icons/search.svg';
import { ReactComponent as SearchBlack } from '../../assets/icons/search-black.svg';
import { ReactComponent as Cancel } from '../../assets/icons/cancel.svg';
import { ReactComponent as CancelBlack } from '../../assets/icons/cancel-black.svg';
import { ReactComponent as Reset } from '../../assets/icons/reset.svg';
import { ReactComponent as ResetBlack } from '../../assets/icons/reset-black.svg';
import { sanitizeInput } from '../../utilities/commonFunctions';

const FilterDropdown = ({
  setSelectedKeys,
  selectedKeys,
  confirm,
  clearFilters,
  close,
  dataIndex,
  handleFilterSearch,
  handleReset,
  tableParams,
  placeholder,
}) => {
  const { theme } = useTheme();

  useEffect(() => {
    setSelectedKeys([tableParams?.filters?.[dataIndex] || '']);
  }, [tableParams]);

  return (
    <Flex
      vertical
      gap={12}
      style={{
        padding: 16,
        backgroundColor: theme === DARK ? '#000000' : '#FFFFFF',
      }}
      onKeyDown={e => e.stopPropagation()}
    >
      <Flex gap={12} justify="flex-end">
        <Icon
          component={theme === DARK ? Reset : ResetBlack}
          onClick={() =>
            clearFilters &&
            handleReset(clearFilters, setSelectedKeys, dataIndex, confirm)
          }
        />
        <Icon
          component={theme === DARK ? Cancel : CancelBlack}
          onClick={close}
        />
      </Flex>
      <Input
        placeholder={placeholder}
        suffix={
          <Icon
            component={theme === DARK ? Search : SearchBlack}
            width={20}
            height={20}
            onClick={() => handleFilterSearch(selectedKeys, confirm, dataIndex)}
          />
        }
        value={selectedKeys[0]}
        size="large"
        className="input-search"
        onChange={e =>
          setSelectedKeys(
            e.target.value ? [sanitizeInput(e.target.value)] : ['']
          )
        }
        onPressEnter={() =>
          handleFilterSearch(selectedKeys, confirm, dataIndex)
        }
        style={{
          marginBottom: 8,
        }}
      />
    </Flex>
  );
};

FilterDropdown.propTypes = {
  setSelectedKeys: PropTypes.func.isRequired,
  selectedKeys: PropTypes.array.isRequired,
  confirm: PropTypes.func.isRequired,
  clearFilters: PropTypes.func,
  close: PropTypes.func.isRequired,
  dataIndex: PropTypes.string.isRequired,
  handleFilterSearch: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
  tableParams: PropTypes.object,
  placeholder: PropTypes.string,
};

export default FilterDropdown;
